import React from "react";
import PropTypes from "prop-types";
import {
  createMuiTheme,
  StylesProvider,
  ThemeProvider as MuiThemeProvider,
} from "@material-ui/core/styles/index";

import "../fonts/Roobert.css";

const white = {
  main: "#F2F6F5",
};

const grey = {
  light: "#DCD6CB",
  main: "#2D2D2D",
  dark: "#181818",
  contrastText: white.main,
};

const blue = {
  light: "#9EB0FE",
  main: "#5D7CFE",
  dark: "#13309E",
  contrastText: grey.main,
};

export const amxPalette = {
  primaryBlue: blue,
  secondaryPink: {
    light: "#FFACC8",
    main: "#FF75A3",
    dark: "#A71353",
    contrastText: grey.main,
  },
  blue,
  green: {
    light: "#66E3B3",
    main: "#00D180",
    dark: "#065C4B",
    contrastText: white.main,
  },
  orange: {
    light: "#FFCE1A",
    main: "#FF9700",
    dark: "#FF7300",
  },
  yellow: {
    light: "#FFF197",
    main: "#FFE752",
    dark: "#FF7300",
  },
  grey,
  white,
};

export const chartPalette = [
  "#fe75a3",
  "#5d7cfc",
  "#02d17f",
  "#ffacc8",
  "#9daffd",
  "#fff198",
  "#67e2b3",
  "#ffe753",
  "#ec4f86",
  "#d83377",
  "#a50e51",
  "#505ce9",
  "#4041cf",
  "#12309e",
  "#02a475",
  "#047d6b",
  "#035c4a",
  "#ffce1a",
  "#ff9700",
  "#ff7300",
  "#7c7771",
  "#938676",
  "#dcd5cb",
  "#b7a893",
];

export const theme = createMuiTheme({
  palette: {
    primary: amxPalette.primaryBlue,
    secondary: amxPalette.secondaryPink,
    info: amxPalette.blue,
    success: amxPalette.green,
    warning: amxPalette.orange,
  },
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: amxPalette.primaryBlue.main,
      },
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: amxPalette.primaryBlue.main,
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: "0.729vw",
      },
    },
    MuiButton: {
      containedPrimary: {
        color: amxPalette.white.main,
      },
      outlined: {
        "&:hover": {
          color: amxPalette.secondaryPink.main,
          backgroundColor: "none",
        },
      },
    },
    MuiPaper: {
      root: {
        boxSizing: "border-box",
      },
      elevation1: {
        boxShadow: "0px 0px 30px rgba(0, 0, 0, 0.05)",
        borderRadius: "5px",
      },
    },
    MuiCheckbox: {
      colorSecondary: {
        color: amxPalette.primaryBlue.main,
        "&$checked": {
          color: amxPalette.primaryBlue.main,
        },
      },
    },
    MuiIconButton: {
      colorSecondary: {
        color: amxPalette.secondaryPink.main,
      },
    },
  },
  typography: {
    fontFamily: ["Roobert", "Arial", "sans-serif"].join(","),
    body1: {
      fontSize: "1.1vw",
      fontWeight: 300,
    },
    body2: {
      fontSize: "1vw",
      fontWeight: 300,
    },
    h2: {
      fontSize: "3.125vw",
    },
    h3: {
      fontSize: "2.500vw",
    },
    h4: {
      fontSize: "2.4vw",
    },
    h5: {
      fontSize: "1.7vw",
    },
    h6: {
      fontWeight: 400,
      fontSize: "1.042vw",
    },
  },
});

export const ThemeProvider = (props) => {
  return (
    <MuiThemeProvider theme={theme}>
      <StylesProvider injectFirst>{props.children}</StylesProvider>
    </MuiThemeProvider>
  );
};

ThemeProvider.propTypes = {
  /**
   * The content to wrap the ThemeProvider around.
   */
  children: PropTypes.element,
};
